// --------------------------------------------------------------
// Created On: 2021-10-12
// Author: Zachary Thomas
//
// Last Modified: 2026-04-13
// Modified By: Dimitra Weinstein
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import useReduxDispatch from "src/hooks/useReduxDispatch";
import useReduxSelector from "../../../../hooks/useReduxSelector";
import { setCurrentUser } from "src/redux/features/currentUserSlice";

// A single company in a company list.
export default function CompanyListItem(props: Props): Component {
  const currentUser = useReduxSelector((state) => state.currentUser);
  const dispatch = useReduxDispatch();

  // Visit the select company as an admin.
  function visitCompany(companyId: number, companyName: string, isPackager: boolean): void {
    dispatch(
      setCurrentUser({
        userId: currentUser.userId,
        userName: currentUser.userName,
        emailAddress: currentUser.emailAddress,
        originalCompanyId: currentUser.originalCompanyId,
        originalCompanyName: currentUser.originalCompanyName,
        companyId: companyId,
        companyName: companyName,
        subsidiaryCompanyId: currentUser.subsidiaryCompanyId,
        subsidiaryCompanyName: currentUser.subsidiaryCompanyName,
        isCompanyHidden: false,
        permissions: currentUser.permissions,
        isPackager: isPackager,
        mfaEnabled: currentUser.mfaEnabled,
        isInSubsidiary: currentUser.isInSubsidiary,
      })
    );
  }

  return (
    <div className="company-list-item p-2" onClick={() => visitCompany(props.companyId, props.name, props.isPackager)}>
      {props.name}
    </div>
  );
}

interface Props {
  companyId: number;
  name: string;
  isPackager: boolean;
}
